<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-tabs v-model="tabIndex" @tab-click="getList">
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{tab.name}}</div>
					<div v-if="tab.num != 0" style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;" class="d-flex">
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{tab.num}}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>

		<el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column align="center" prop="id" label="编号" width="50" fixed="left"></el-table-column>
			<el-table-column prop="nickname" width="150" label="申请用户" fixed="left"></el-table-column>
			<el-table-column prop="username" width="150" label="申请账号"></el-table-column>
			<el-table-column prop="phone" label="电话"></el-table-column>
			<el-table-column align="center" width="100" label="账号状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.glsq == 0">待审核</el-button>
					<el-button type="primary" size="mini" plain v-else>通过</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="关联客户">
				<template slot-scope="scope">
					<div style="color: #0084ff;">{{scope.row.khdata.name}}</div>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="客户编号">
				<template slot-scope="scope">
					<div style="color: #0084ff;">{{scope.row.khdata.j_name}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" width="180" label="申请时间"></el-table-column>

			
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="upstate(scope.row.id,2)" v-if="scope.row.glsq == 0">通过</el-button>
					<el-button type="danger" size="mini" @click="upstate(scope.row.id,1)">{{scope.row.glsq == 0 ? '驳回' : '删除'}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'khzhgl',
			tabIndex: 0,
			tabbars: [{ name: '全部', key: 'all',num:0 }, { name: '待审核', key: 'dsh',num:0 }, { name: '已审核', key: 'ysh',num:0 }],
			tableData: [],
			maxHeight: 0,
			
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},

	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 250;
		});
	},
	methods: {
		
		upstate(e, f) {
			let data = {
				id: e,
				shzt: f,
				glsq_cjr: this.user.id
			}
			this.axios.post('/admin/khzhgl/shzt', data, { token: true })
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
				})
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list
			this.tabbars[1].num = e.dsh
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
